import ReactApexChart from 'react-apexcharts';
import { Box, GridItem, Text } from '@cdl/heartbeat-react';
import { AnnotationTask } from '../../../../ecg/types/annotation-tasks.type';
import { TaskMetricSection } from '../TaskMetricSection';
import { greenLine, greyBorder } from '../../../../utils/colors';

type Props = {
  annotationTask: AnnotationTask;
};

export const OverallProgress: React.FC<Props> = ({ annotationTask }) => {
  const chartOptions: ApexCharts.ApexOptions = {
    chart: {
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    stroke: {
      curve: 'smooth' as const,
    },
    grid: {
      borderColor: greyBorder,
    },
    series: [
      {
        name: 'Ecg done',
        data: annotationTask.cumulDonePerDay as { x: number; y: number }[],
      },
    ],
    tooltip: {
      x: {
        format: 'dd MMM yyyy',
      },
    },
    xaxis: {
      type: 'datetime',

      labels: {
        showDuplicates: false,
        format: 'dd MMM',
      },
    },
    colors: [greenLine],
  };

  return (
    <GridItem colSpan={1}>
      <TaskMetricSection>
        <Text textStyle='category-title'>Overall Progress</Text>
        <Box mt='xl'>
          <ReactApexChart
            options={chartOptions}
            series={chartOptions.series}
            type='line'
            height={200}
          />
        </Box>
      </TaskMetricSection>
    </GridItem>
  );
};
